import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
// import './calendar-style.css';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import mandala from '../../assets/wallpaper.png'; // adjust if it's .png or .jpg
import { useNavigate } from 'react-router-dom';

const GOOGLE_API_KEY = 'AIzaSyAfT-327xEdZC0G1j2Ksuj0fURc38DUxR8';
const CALENDAR_ID = 'ekalakaarevents@gmail.com';

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(
          `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?key=${GOOGLE_API_KEY}&orderBy=startTime&singleEvents=true&timeMin=${new Date().toISOString()}`
        );
        const data = await response.json();
        setEvents(data.items || []);
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };
    fetchEvents();
  }, []);

const decodeHTML = (html) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  return textarea.value;
};



const getUpcomingEvents = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // normalize to midnight

  const uniqueEventsMap = new Map();

  events.forEach((event) => {
    const start = new Date(event.start.dateTime || event.start.date);
    const end = new Date(event.end.dateTime || event.end.date);

    // Normalize to midnight for accurate all-day comparison
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const eventKey = event.recurringEventId || event.id;

    // Include only if the event is today or in the future
  if (start >= today && !uniqueEventsMap.has(eventKey)) {
      uniqueEventsMap.set(eventKey, event);
    }
  });

  // If you still get 0, log for debugging:
  // console.log('Filtered Events:', Array.from(uniqueEventsMap.values()));

  return Array.from(uniqueEventsMap.values()).slice(0, 3);
};



  const getEventsForDate = (date) => {
    return events.filter(event => {
      const eventDate = new Date(event.start.dateTime || event.start.date);
      return eventDate.toDateString() === new Date(date).toDateString();
    });
  };

  const selectedDateEvents = selectedDate ? getEventsForDate(selectedDate) : [];

const getImageUrl = (fileUrl) => {
  if (!fileUrl) return null;

  // Try to extract Google Drive file ID
  const match = fileUrl.match(/[-\w]{25,}/);
  if (match) {
    return `https://drive.google.com/thumbnail?id=${match[0]}&sz=w1000`;
  }

  // Otherwise return original URL if it's not a Drive URL
  return fileUrl;
};


  return (
     <>

      <style>
        {`
          @keyframes typewriter {
            0% {
              clip-path: inset(0 100% 0 0);
            }
            80% {
              clip-path: inset(0 0% 0 0);
            }
            100% {
              clip-path: inset(0 0% 0 0);
            }
          }

          .typewriter {
            display: inline-block;
            
            animation: typewriter 5s steps(30) infinite;
          }

             
        `}
      </style>

 
<div className="bg-white h-[680px] w-full flex items-center justify-center overflow-hidden">
  <div className="font-bold text-[#AD2F3B] text-[32px] max-[440px]:text-[32px] max-[440px]:mx-10 text-center flex flex-wrap justify-center">
    <span className="typewriter break-words max-[440px]:break-words">
     Gallery Coming Soon !!
    </span>
  </div>
</div>
    


< Footer />
</>
 
  );
};

 export default UpcomingEvents;
